import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';


@Component({
	selector: 'rush-dialog',
	imports: [
		DashboardDialogFramePart,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './rush.dialog.html',
})
export class RushDialog {

	yesAction: DialogAction = {
		id: 'yes',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Yes'),
		linkType: 'no-action',
		willCloseDialog: true,
	};

	ofCourseAction: DialogAction = {
		id: 'yes',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Of Course'),
		linkType: 'no-action',
		willCloseDialog: true,
	};

	withoutDoubtAction: DialogAction = {
		id: 'yes',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Without a Doubt'),
		linkType: 'no-action',
		willCloseDialog: true,
	};

	actions: DialogAction[] = [this.yesAction, this.ofCourseAction, this.withoutDoubtAction];

	icon = signal('far fa-guitar-electric');
	header = signal('Best Band');

	private dialog = inject<DialogContext<{ rush: 'Amazing' }>>(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<RushDialog>);

}
